export default {
  shipment: {
    eta: '2019-01-26T00:00:00+00:00',
    carrier: {
      name: 'DHL',
      logoUrl: 'https://s3.eu-central-1.amazonaws.com/7s-cdn/master/carrier_company_logos/12.png',
      trackingCode: 'tracking-nr-5a18d2c76bf97',
      trackingUrl:
        'https://nolp.dhl.de/nextt-online-public/set_identcodes.do?idc=tracking-nr-5a18d2c76bf97&rfn=&extendedSearch=true',
    },
  },
  orderItems: [
    {
      id: 1035,
      name: 'Product A',
      size: 'Small',
      price: 29,
      currency: 'EUR',
      productImageUrl:
        'https://7s-cdn.s3.eu-central-1.amazonaws.com/master/product_images/return-portal-preview/grey-trousers.jpg',
      sku: 'SKU_1009',
    },
    {
      id: 1036,
      name: 'Product B',
      size: 'Large',
      price: 12,
      currency: 'EUR',
      productImageUrl:
        'https://7s-cdn.s3.eu-central-1.amazonaws.com/master/product_images/return-portal-preview/white-bag.jpg',
      sku: 'SKU_1004',
    },
  ],
};
